module.exports = __webpack_public_path__ + "img/thumbnail_FireSalamander_u_normal.832bbac6.png";